import FieldDefs from './AdsByKeywordFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import Months from "../ads/mixins/Months";

/**
 * Объявления по фразе — только помесячный архив рекламы, текущего состояния нет:
 * без ?month= — последний месяц из списка.
 */
export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [Months],
    props: {
        db: {
            type: String,
            required: true,
        },
        keyword: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            fields: doLangFields(this, "lang.report.ads_by_keyword.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'keyscnt',
                    direction: 'desc'
                }
            ],
            monthsPath: '/report/simple/context/keyword/ads/archive/months',
            withCurrentState: false,
            // таблицу показываем, когда выбран месяц: без ?month= он известен только после загрузки списка
            ready: false,
        }
    },
    computed: {
        self() {
            return this;
        },
        monthsParams() {
            return {base: this.db, keyword: this.keyword};
        },
        apiUrl() {
            const params = new URLSearchParams({base: this.db, keyword: this.keyword, month: this.month});

            return `/report/simple/context/keyword/ads/archive?${params}`;
        },
    },
}
